import Index from '@/views/Admin/Index';
import FeatureIdeas from '@/views/Admin/FeatureIdeas';
import RequestDebug from '@/views/Admin/RequestDebug';
import SurveyResponses from '@/views/Admin/SurveyResponses';
import UserSearch from '@/views/Admin/UserSearch';

const routes = [
  {
    name: 'admin/index',
    path: '/admin',
    component: Index,
    meta: {
      icon: 'crown',
      title: 'Metrics',
    },
  },
  {
    name: 'admin/feature-ideas',
    path: '/admin/feature-ideas',
    component: FeatureIdeas,
    meta: {
      icon: 'lightbulb',
      title: 'Feature Ideas',
    },
  },
  {
    name: 'admin/debug/request',
    path: '/admin/debug/request',
    component: RequestDebug,
    meta: {
      icon: 'bug',
      title: 'Request Debug',
    },
  },
  {
    name: 'admin/survey-responses',
    path: '/admin/survey-responses',
    component: SurveyResponses,
    meta: {
      icon: 'chart-column',
      title: 'Survey Responses',
    },
  },
  {
    name: 'admin/users/search',
    path: '/admin/users/search',
    component: UserSearch,
    meta: {
      icon: 'search',
      title: 'Search Users',
    },
  },
];

export default routes;
